import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkService } from '../../../services/network.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { CaptchaRequestField } from '../../../models/captcha-request-field';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isLoggedin: boolean = false;
  loginForm: FormGroup;
  visibleCard: string = "LOGIN";
  showV2Captcha: boolean = false;
  dialogRef: MatDialogRef<LoginComponent>;

  constructor(private networkService: NetworkService, private router: Router, private fb: FormBuilder,
    private recaptchaV3Service: ReCaptchaV3Service, private injector: Injector, private snackBar: MatSnackBar) {
      try{
        this.dialogRef = this.injector.get(MatDialogRef)
      }catch(Error){

      }
      console.log(this.dialogRef)
      // private dialogRef: MatDialogRef<ChoiceDialogComponent>
     }

  /*login(){
    this.networkService.login(()=>{
      this.router.navigate(['/overview'])
    }, (error)=>{
      
    });
  }*/

  public handleToken(token){
    let email: string = this.loginForm.get("email").value;
    let password: string = this.loginForm.get("password").value;

    let captchaObject: CaptchaRequestField = {type: "V3", token: token};

    this.networkService.login(email, password, captchaObject, (resp)=>{
      let respState = resp.body.data.state;
      if(respState == 1){
        if(this.dialogRef == undefined){
          this.router.navigate(['/overview'])
        }else{
          this.closeLogin();
        }
        
      }else if(respState == 3){
        this.snackBar.open("Falsche Logindaten")
      }else if(respState == 3){
        alert("2FA not yet implemented")
      }else if(respState == 4){
        this.snackBar.open("Bitte aktiviere dein Konto über die E-Mail die du bei der Registrierung bekommen hast.")
      }
      
    }, (error)=>{
      if(error.error.exception[0].message == "Invalid Captcha Version used by client." || error.error.exception[0].message == "Invalid Captcha. Captcha V2 activated."){
        this.showV2Captcha = true;
        console.log("Captcha V2 is now being displayed")
      }
      
    });
  }

  private closeLogin(){
    this.dialogRef.close();
  }

  resolvedV2(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    let email: string = this.loginForm.get("email").value;
    let password: string = this.loginForm.get("password").value;

    let captchaObject: {type: string, token: string} = {type: "V2", token: captchaResponse};
    this.networkService.login(email, password, captchaObject, (resp)=>{
      console.log(resp)
      let respState = resp.body.data.state;
      if(respState == 1){
        if(this.dialogRef == undefined){
          this.router.navigate(['/overview'])
        }else{
          this.closeLogin();
        }
      }else if(respState == 3){
        this.snackBar.open("Falsche Logindaten")
      }else if(respState == 3){
        alert("2FA not yet implemented")
      }else if(respState == 4){
        this.snackBar.open("Bitte aktiviere dein Konto über die E-Mail die du bei der Registrierung bekommen hast.")
      }
      
    }, (error)=>{
      console.error(error)      
    });
}

  public executeImportantAction(): void {
    this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => this.handleToken(token));
  }


  ngOnInit() {
    this.networkService.checkLogin((resp)=>{
      let isLoggedin = resp.success;
      this.isLoggedin = isLoggedin;
      if(isLoggedin){
        this.router.navigate(['/overview'])
      }
    }, (error)=>{
      console.error(error)
    })

    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    }, {})
  }
}